import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionEyebrowProps {
    children: ReactNode
    /** Accent colour for the glowing node + hairline. */
    color?: string
    align?: 'left' | 'center'
    className?: string
}

/* The standard label that sits above every section title — a glowing
   accent node, the tracked caption, and a fading hairline. Echoes the
   eyebrow pill and route motif from the hero. */
export const SectionEyebrow: FC<SectionEyebrowProps> = ({
    children,
    color = '#E94E1B',
    align = 'left',
    className
}): ReactNode => {
    return (
        <div
            className={cn(
                'flex items-center gap-3',
                align === 'center' && 'justify-center',
                className
            )}
        >
            <span
                className='h-1.5 w-1.5 shrink-0 rounded-full'
                style={{ background: color, boxShadow: `0 0 10px ${color}` }}
            />
            <span
                className='text-[11px] font-bold tracking-[0.24em]'
                style={{ color }}
            >
                {children}
            </span>
            <span
                className='h-px w-10'
                style={{
                    background: `linear-gradient(90deg, ${color}99, transparent)`
                }}
            />
        </div>
    )
}
